import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { CommonImportFileResponse, CreateOrEditOutletInfoDto, GetAllOutletNoFilterDto, GetAllRetailerUpdatePhoneInput, GetOutletInfoForEditOutput, OutletInfosImportAgrs, PagedResultDtoOfGetAllOutletNoFilterDto, PagedResultDtoOfOutletInfoUpdateHistoryDto, SocialRetailerFileDto } from '@shared/service-proxies/service-proxies';
import { PagedResultDtoOfGetOutletInfoForViewDto } from '@shared/service-proxies/service-proxies';
import { API_ENDPOINTS } from '@shared/APIEndpoint';
import * as moment from "moment";
import { HttpParams } from '@angular/common/http';
import { BaseApiService } from './base-api-service';
import { AppConsts } from '@shared/AppConsts';

@Injectable({ providedIn: 'root' })
export class OutletInfoService extends BaseApiService {
    protected prefix = AppConsts.apiGatewayPartnerPrefix;

    constructor(api: ApiService) {
        super(api);
    }

    getAllRetailerUpdatePhone(
        brand?: string,
        filter?: string,
        ids?: number[],
        name?: string,
        phone?: string,
        outletType?: string,
        statusFilter?: string,
        phoneUpdateStatusFilter?: string,
        maxPhoneUpdatedDateFilter?: moment.Moment,
        minPhoneUpdatedDateFilter?: moment.Moment,
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number
    ): Observable<PagedResultDtoOfGetOutletInfoForViewDto> {
        const url = API_ENDPOINTS.OutletInfo.GetAllRetailerUpdatePhone;

        let params = new HttpParams();

        // string params (null thì bỏ, "" thì giữ)
        params = params.set("brand", brand != null ? brand : "");
        params = params.set("Filter", filter != null ? filter : "");
        params = params.set("Name", name != null ? name : "");
        params = params.set("Phone", phone != null ? phone : "");
        params = params.set("OutletType", outletType != null ? outletType : "");
        params = params.set("StatusFilter", statusFilter != null ? statusFilter : "");
        params = params.set("PhoneUpdateStatusFilter", phoneUpdateStatusFilter != null ? phoneUpdateStatusFilter : "");
        params = params.set("Sorting", sorting != null ? sorting : "");

        // ids (mảng, có thì append, không thì bỏ)
        if (ids && ids.length > 0) {
            ids.forEach(item => {
                params = params.append("Ids", item.toString());
            });
        }

        // dates
        if (maxPhoneUpdatedDateFilter)
            params = params.set("MaxPhoneUpdatedDateFilter", maxPhoneUpdatedDateFilter.toJSON());
        if (minPhoneUpdatedDateFilter)
            params = params.set("MinPhoneUpdatedDateFilter", minPhoneUpdatedDateFilter.toJSON());

        // numbers (luôn giữ, default 0)
        params = params.set("SkipCount", skipCount != null ? skipCount.toString() : "0");
        params = params.set("MaxResultCount", maxResultCount != null ? maxResultCount.toString() : "10");

        return this.get<PagedResultDtoOfGetOutletInfoForViewDto>(url, params);
    }

    getAllRetailerUpdatePhone_Simple(
        filter: string | null | undefined,
        ids: number[] | null | undefined,
        name: string | null | undefined,
        phone: string | null | undefined,
        outletType: string | null | undefined,
        statusFilter: string | null | undefined,
        phoneUpdateStatusFilter: string | null | undefined,
        maxPhoneUpdatedDateFilter: moment.Moment | null | undefined,
        minPhoneUpdatedDateFilter: moment.Moment | null | undefined,
        sorting: string | null | undefined,
        skipCount: number | null | undefined,
        maxResultCount: number | null | undefined
    ): Observable<GetAllOutletNoFilterDto[]> {

        const url = API_ENDPOINTS.OutletInfo.GetAllRetailerUpdatePhone_Simple;

        const params: any = {};

        if (filter !== undefined && filter !== null) {
            params.Filter = filter;
        }

        if (ids !== undefined && ids !== null && ids.length > 0) {
            params.Ids = ids;
        }

        if (name !== undefined && name !== null) {
            params.Name = name;
        }

        if (phone !== undefined && phone !== null) {
            params.Phone = phone;
        }

        if (outletType !== undefined && outletType !== null) {
            params.OutletType = outletType;
        }

        if (statusFilter !== undefined && statusFilter !== null) {
            params.StatusFilter = statusFilter;
        }

        if (phoneUpdateStatusFilter !== undefined && phoneUpdateStatusFilter !== null) {
            params.PhoneUpdateStatusFilter = phoneUpdateStatusFilter;
        }

        if (maxPhoneUpdatedDateFilter !== undefined && maxPhoneUpdatedDateFilter !== null) {
            params.MaxPhoneUpdatedDateFilter = maxPhoneUpdatedDateFilter.toJSON();
        }

        if (minPhoneUpdatedDateFilter !== undefined && minPhoneUpdatedDateFilter !== null) {
            params.MinPhoneUpdatedDateFilter = minPhoneUpdatedDateFilter.toJSON();
        }

        if (sorting !== undefined && sorting !== null) {
            params.Sorting = sorting;
        }

        if (skipCount !== undefined && skipCount !== null) {
            params.SkipCount = skipCount;
        }

        if (maxResultCount !== undefined && maxResultCount !== null) {
            params.MaxResultCount = maxResultCount;
        }

        return this.get<GetAllOutletNoFilterDto[]>(url, params);
    }

    exportTemplate(): Observable<SocialRetailerFileDto> {

        return this.post<SocialRetailerFileDto>(API_ENDPOINTS.OutletInfo.ExportTemplate, {});
    }

    importQueueRetailer(arg?: OutletInfosImportAgrs): Observable<CommonImportFileResponse> {

        return this.post<CommonImportFileResponse>(API_ENDPOINTS.OutletInfo.ImportQueueRetailer, arg != null ? arg : {});
    }

    exportCustomRetailer(input?: GetAllRetailerUpdatePhoneInput): Observable<SocialRetailerFileDto> {

        return this.post<SocialRetailerFileDto>(API_ENDPOINTS.OutletInfo.ExportCustomRetailer, input != null ? input : {});
    }

    getRetailerForEdit(
        id?: number,
        memberCode?: string,
        requestCode?: string,
        requestType?: number,
        phone?: string
    ): Observable<GetOutletInfoForEditOutput> {
        const url = API_ENDPOINTS.OutletInfo.GetRetailerForEdit;

        let params = new HttpParams();
        if (id != null) params = params.set("Id", id.toString());
        if (memberCode != null) params = params.set("MemberCode", memberCode);
        if (requestCode != null) params = params.set("RequestCode", requestCode);
        if (requestType != null) params = params.set("RequestType", requestType.toString());
        if (phone != null) params = params.set("Phone", phone);

        return this.get<GetOutletInfoForEditOutput>(url, params);
    }

    editOutlet(input: GetOutletInfoForEditOutput): Observable<void> {
        //return this.post<void>(API_ENDPOINTS.OutletInfo.EditOutlet, input);
        return this.post<void>(API_ENDPOINTS.OutletInfo.CreateOrEditOutlet, input);
    }

    unlockOutlet(memberCode?: string): Observable<boolean> {
        let params = new HttpParams();
        if (memberCode != null) {
            params = params.set("MemberCode", memberCode);
        }

        return this.post<boolean>(API_ENDPOINTS.OutletInfo.UnlockOutlet, {}, params);
    }

    getOutletInfoUpdateHistory(
        outletId?: number,
        outletCode?: string,
        oldContent?: string,
        newContent?: string,
        type?: string,
        sorting?: string,
        skipCount: number = 0,
        maxResultCount: number = 10
    ): Observable<PagedResultDtoOfOutletInfoUpdateHistoryDto> {
        const url = API_ENDPOINTS.OutletInfoUpdateHistory.GetAll;

        let params = new HttpParams();

        if (outletId != null) params = params.set('OutletId', outletId.toString());
        if (outletCode != null) params = params.set('OutletCode', outletCode);
        if (oldContent != null) params = params.set('OldContent', oldContent);
        if (newContent != null) params = params.set('NewContent', newContent);
        if (type != null) params = params.set('Type', type);
        if (sorting != null) params = params.set('Sorting', sorting);

        params = params.set('SkipCount', skipCount.toString());
        params = params.set('MaxResultCount', maxResultCount.toString());

        return this.get<PagedResultDtoOfOutletInfoUpdateHistoryDto>(url, params);
    }

    getEditRequiredConfig(key: string): Observable<ValidationConfigResponse> {
        let params = new HttpParams();
        if (key != null) {
            params = params.set("Key", key);
        }
        return this.get<ValidationConfigResponse>(API_ENDPOINTS.OutletInfo.GetEditRequiredConfig, params);
    }

    createOrEditDistributorAccount(input: CreateOrEditOutletInfoDto | null | undefined): Observable<boolean> {
        return this.post<boolean>(API_ENDPOINTS.OutletInfo.CreateOrEditDistributorAccount, input);
    }


    taxcodeValidate(input: { id: number, taxCode: string, memberCode: string | null, outletType: string | null })
        : Observable<TaxInfoDto> {
        return this.post<TaxInfoDto>(API_ENDPOINTS.OutletInfo.TaxcodeValidate, input);
    }



    deleteOutLet(memberCode: string | null | undefined, note: string | null | undefined): Observable<boolean> {
        let params = new HttpParams();
        if (memberCode != null) {
            params = params.set("memberCode", memberCode);
        }
        if (note != null) {
            params = params.set("note", note);
        }

        return this.delete<boolean>(API_ENDPOINTS.OutletInfo.DeleteOutLet, params);
    }


    downloadTempFile(
        fileName?: string,
        fileType?: string,
        fileToken?: string
    ): Observable<Blob> {
        const url = API_ENDPOINTS.File.DownloadTempFile;

        let params = new HttpParams();
        if (fileName != null) params = params.set("FileName", fileName);
        if (fileType != null) params = params.set("FileType", fileType);
        if (fileToken != null) params = params.set("FileToken", fileToken);

        return this.getBlob(url, params);
    }

    IdentificationValidate(input: IdentificationValidateDto | null | undefined): Observable<boolean | { message: string }> {
        return this.post<boolean | { message: string }>(API_ENDPOINTS.OutletInfo.IdentificationValidate, input);
    }

    GetDistributorOutletsForExport(outletType: string | null | undefined): Observable<PagedResultDtoOfGetAllOutletNoFilterDto> {
        let params = new HttpParams();
        if (outletType != null) {
            params = params.set("OutletType", outletType);
        }
        return this.get<PagedResultDtoOfGetAllOutletNoFilterDto>(API_ENDPOINTS.OutletInfo.GetDistributorOutletsForExport, params);
    }
}

export interface TaxInfoDto {
    orgType?: string | null;
    taxID?: string | null;
    name?: string | null;
    address?: string | null;
    taxDepartment?: string | null;
    status?: string | null;
    message?: string | null;
    updatedAt?: Date | null;
}

export interface ValidationConfigResponse {
    [key: string]: {
        [field: string]: string[];
    };
}

export interface IdentificationValidateDto {
    id?: number;
    identificationCardNumber: string;
    memberCode?: string;
    legalPersonal?: string;
    outletType?: string;
    isMobile?: boolean;
    storeType?: string;
}
